import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import PageActions from '../../common/PageActions';
import LoginPageStyleFooter from '../../common/LoginPageStyleFooter/LoginPageStyleFooter.component';
import ImprintDe from '../../assets/legal/Imprint_Verbund_Energy4Business_de.pdf';
import ImprintEn from '../../assets/legal/Imprint_Verbund_Energy4Business_en.pdf';
import s from './Imprint.module.scss';

const footerLinks = [
  {
    de: 'https://vision.verbund.com/data-protection?locale=de',
    en: 'https://vision.verbund.com/data-protection?locale=en',
    i18n: 'contactpage.dataProtection',
  },
  {
    de: '/kontakt/imprint',
    en: '/kontakt/imprint',
    i18n: 'contactpage.imprintDisclosure',
  },
];

const DOWNLOAD_IMPRINT = {
  de: ImprintDe,
  en: ImprintEn,
};

class Imprint extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { intl } = this.props;
    const { locale } = intl;

    return (
      <>
        <div className={s.container}>
          <div className={s.contentWrapper}>
            <div className={s.header}>
              <h1 className={s.modalHeading}>
                <FormattedMessage id="imprint.header" />
                <PageActions download={DOWNLOAD_IMPRINT[locale]} />
              </h1>
            </div>
            <div className={s.content}>
              <div>
                <h2 className={s.subHeading}>
                  <FormattedMessage id="imprint.text0" />
                </h2>
                <ul className="list-unstyled">
                  <li>VERBUND Energy4Business GmbH</li>
                  <li>Am Hof 6a</li>
                  <li>
                    <FormattedMessage id="imprint.text1" />
                  </li>
                </ul>
                <ul className="list-unstyled">
                  <li>T +43 (0)50313-0</li>
                  <li>F +43 (0)50313-54191</li>
                  <li>
                    E{' '}
                    <a className="link" href="mailto:business@verbund.com">
                      business@verbund.com
                    </a>
                  </li>
                </ul>
                <p>
                  <FormattedMessage id="imprint.text2" />
                </p>
                <ul className="list-unstyled">
                  <li>
                    <FormattedMessage id="imprint.text3" />
                  </li>
                  <li>
                    <FormattedMessage id="imprint.text4" />
                  </li>
                  <li>
                    <FormattedMessage id="imprint.text5" />
                  </li>
                  <li>
                    <FormattedMessage id="imprint.text6" />
                  </li>
                  <li>
                    <FormattedMessage id="imprint.text7" />
                  </li>
                </ul>
                <ul className="list-unstyled">
                  <li>
                    <FormattedMessage id="imprint.text8" />
                  </li>
                  <li>
                    <FormattedMessage id="imprint.text9" />
                  </li>
                  <li>
                    <FormattedMessage id="imprint.text10" />
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <LoginPageStyleFooter links={footerLinks} fixed />
      </>
    );
  }
}

Imprint.propTypes = {
  intl: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};

export default injectIntl(Imprint);
